export default {
    list: {
        title: 'Uživatelé',
        empty: 'Žádní uživatelé',
        cols: {
            name: 'Jméno',
            username: 'Username',
            email: 'E-mail',
            active: 'Aktivní',
            admin: 'Admin'
        },
        fullNameFallback: '(bez jména)'
    },
    filter: {
        search: 'Hledat (jméno, username nebo e-mail)',
        active: 'Aktivní',
        activeOptions: {
            all: 'Vše',
            active: 'Aktivní',
            inactive: 'Neaktivní'
        }
    },
    form: {
        firstName: 'Jméno',
        lastName: 'Příjmení',
        email: 'E-mail',
        validUntil: 'Platnost účtu (do)',
        isActive: 'Aktivní',
        isSuperuser: 'Administrátor',
        section: {
            edit: 'Editovat',
            rights: 'Práva',
            metadata: 'Metadata'
        }
    },
    metadata: {
        username: 'Username',
        dateJoined: 'Datum registrace',
        lastLogin: 'Poslední login',
        lastLoginNever: 'Nikdy',
        isStaff: 'isStaff',
        yes: 'Ano',
        no: 'Ne'
    },
    rights: {
        cols: {
            instance: 'Instance',
            bzucoAdmin: 'Bzuco admin',
            manageUsers: 'Uživatelé',
            manageEvents: 'Události',
            manageTicketsets: 'Sady',
            manageTickets: 'Vstupenky',
            manageDevices: 'Zařízení',
            stats: 'Statistiky',
            primary: 'Primární'
        },
        empty: 'Uživatel nemá žádné instance',
        savePerRow: 'Uložit',
        dirtyIndicator: 'neuložené změny'
    },
    bzucoSynced: {
        primaryTooltip: 'Primární instance — určuje login mutation, nelze upravovat'
    },
    confirm: {
        deleteTitle: 'Smazat uživatele?',
        deleteBody: 'Opravdu chcete smazat uživatele „{name}"?',
        deletePermissionTooltip: 'Pouze superuser může mazat uživatele',
        unsavedChanges: 'Máte neuložené změny. Opravdu zavřít?'
    },
    toast: {
        profileSaved: 'Profil uložen',
        rightsSaved: 'Práva uložena',
        deleted: 'Uživatel smazán'
    }
}
